import { createRouter } from "@tanstack/react-router";
import { DefaultCatchBoundary } from "~/components/default-catch-boundary";
import { NotFound } from "~/components/not-found";
import { queryClient } from "~/lib/query-client";
import { resolvePageViewTransitionTypes } from "~/lib/page-view-transitions";
import { localeUrlRewrite } from "~/lib/language-lens";
import { createRouterRuntimeContext } from "~/lib/router-runtime";
import { routeTree } from "~/routeTree.gen";

export const router = createRouter({
  routeTree,
  rewrite: localeUrlRewrite,
  context: createRouterRuntimeContext({
    queryClient,
  }),
  defaultPreload: "intent",
  // Route loaders delegate server-data freshness and dedupe to TanStack Query.
  // A zero router window prevents a second cache policy from masking Query's.
  defaultPreloadStaleTime: 0,
  scrollRestoration: true,
  defaultViewTransition: {
    types: resolvePageViewTransitionTypes,
  },
  defaultErrorComponent: DefaultCatchBoundary,
  defaultNotFoundComponent: () => <NotFound />,
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
